export default __webpack_public_path__ + "static/media/checkbox-checked.265ca914.svg";